/**
 * Deal version export file names — kept in sync with spa-datastage
 * DealVersionExportNaming.kt (RIGHTS-31009).
 */

const SNAPSHOT_DESCRIPTION_PATTERN =
    /^Deal Snapshot (\d+)(?: \(v([^)]+)\))?$/;

function isSnapshotCapture(dealVersion) {
    return (dealVersion.dealVersionKey?.subversion ?? 0) > 0;
}

function versionTokenForFilename(version) {
    return `v${String(version).replace(/\./g, '_')}`;
}

function parseSnapshotDescription(snapshotDescription) {
    if (!snapshotDescription?.trim()) {
        return null;
    }
    const match = snapshotDescription.trim().match(SNAPSHOT_DESCRIPTION_PATTERN);
    if (!match) {
        return null;
    }
    return {
        snapshotNumber: parseInt(match[1], 10),
        versionAtSnapshot: match[2] ?? null,
    };
}

/**
 * @param {Object} dealVersion - Grid row / API deal version object
 * @param {string} extension - e.g. pdf, xlsx
 * @returns {string}
 */
export function singleExportFileName(dealVersion, extension) {
    const dealId = dealVersion.dealVersionKey.dealId;
    const version = dealVersion.dealVersionKey.version;
    const subversion = dealVersion.dealVersionKey.subversion;
    const snapshotDescription = dealVersion.snapshotDescription ?? null;
    const sanitizedExt = extension.replace(/^\./, '');

    if (isSnapshotCapture(dealVersion)) {
        const parsed = parseSnapshotDescription(snapshotDescription);
        const snapshotNum = parsed?.snapshotNumber ?? (subversion || 1);
        const base = `Deal_${dealId}_DealSnapshot_${snapshotNum}`;
        const versionAtSnapshot = parsed?.versionAtSnapshot ?? version;
        const withVersion =
            parsed?.versionAtSnapshot != null || snapshotDescription?.includes('(v')
                ? `${base}_${versionTokenForFilename(versionAtSnapshot)}`
                : base;
        return `${withVersion}.${sanitizedExt}`;
    }

    return `Deal_${dealId}_DealVersion_${versionTokenForFilename(version)}.${sanitizedExt}`;
}
